import React from 'react';
import { HistorySate } from '../types/history-state';

const initialValue = {
};

export const HistoryContext = React.createContext<HistorySate>(initialValue)